import {MtplQuotation} from "../../../../model/quotation";
import {showOrNotTechnicalWorkPage} from "../../../MessagePage";
import {calculate, Response} from "../../../../api/quotationApiClient";
import {QuoationPackage} from "../../../../model/quoationPackage";
import {strings} from "../../../../strings/strings";
import {useContext, useEffect, useState} from "react";
import {QuotationContext} from "../../../../contexts/QuotationContext";
import {Duration} from "../../../../model/contract";
import {ScenarioContext} from "../../../../contexts/ScenarioContext";
import {StepContext} from "../../../../contexts/StepContext";
import {ProcessingContext} from "../../../../contexts/ProcessingContext";
import * as log from "../../../../utils/log";
import {LogFunctionalModule} from "../../../../utils/log";
import {ProductType} from "../../../../api/model/common";

export const useTariffication = (currentStepCode, setTextErrorMessageDialog, setTextDetailErrorMessageDialog, setOpenErrorMessageDialog) => {
    const {quotation, setQuotation, setTotalPremium, packages, setPackages, setSelectedDeductible, setSelectedPackage, setSelectedVtplSumInsured, setSelectedVtplCovered, setSelectedVtplPremium, setSelectedProgram, setTarrificationProgram, defaultTariffied, saveTempValues} = useContext<QuotationContext<MtplQuotation>>(QuotationContext);
    const [tariffied, setTariffied] = useState(defaultTariffied);
    const {currentStep, previousStep} = useContext(ScenarioContext);
    const {nextStepListener} = useContext(StepContext);
    const {setProcessingOpen} = useContext(ProcessingContext);

    useEffect(() => {
        setTarrificationProgram(currentStepCode);
        if (previousStep && (previousStep.code === "mtpl_online_00002" || previousStep.code === 'mtpl_online_00005') && currentStep && currentStep.code === currentStepCode) {
            setProcessingOpen(true);
            setTariffied(true);
            setProcessingOpen(false);
        }
    }, []);

    const getDefaultPackage = (submittedQuotation: MtplQuotation, quotationPackage: QuoationPackage[]) => {
        const res =  quotationPackage.filter(el => {
            return !(el.deductible === 0 && (submittedQuotation.mtplContract.vehicle.taxiUsage || submittedQuotation.mtplContract.duration !== Duration.YEAR_1));
        });
        return quotationPackage.length > 1 ? res.shift() : quotationPackage[0];
    }

    const handleCalculationResponse = (response: Response, submittedQuotation: any) => {
        if (!response.success) {
            handleCalculationError(response);
            return;
        }

        const sortedData = sortPackagesByDeductible(response.data);
        processCascoAdditionalCoverage(sortedData);

        const quotationPackages: QuoationPackage[] = sortedData as QuoationPackage[];
        const defaultPackage = getDefaultPackage(submittedQuotation, quotationPackages);

        updateStateWithPackages(quotationPackages, defaultPackage);
        window.scrollTo(0, 0);
    };

    const sortPackagesByDeductible = (packages: any[]) => {
        return packages.sort((a, b) => {
            if (a.deductible === null || a.deductible === undefined) return 1;
            if (b.deductible === null || b.deductible === undefined) return -1;
            return a.deductible - b.deductible;
        });
    };

    const processCascoAdditionalCoverage = (packages: any[]) => {
        packages.forEach(pkg => {
            if (pkg.cascoAdditionalCoverage?.length) {
                let result = {};
                pkg.cascoAdditionalCoverage[0].cascoSmartDriveCalculations.forEach(({scoreScale, secondPartOfPayment, discountSize}) => {
                    result[scoreScale] = {
                        secondPartOfPayment,
                        discountSize
                    }
                })
                pkg.cascoAdditionalCoverage.cascoSmartDriveCalculations = result;
            }
        });
    };

    const updateStateWithPackages = (quotationPackages: QuoationPackage[], defaultPackage: QuoationPackage) => {
        setPackages(quotationPackages);
        saveTempValues('packages', JSON.stringify(quotationPackages));

        setSelectedDeductible(defaultPackage?.deductible ?? null);
        setSelectedPackage(defaultPackage);
        saveTempValues('selectedPackage', JSON.stringify(defaultPackage));

        setSelectedProgram(undefined);
        setTariffied(true);
        setProcessingOpen(false);
    };

    const handleCalculationError = (response: Response) => {
        setProcessingOpen(false);
        setSelectedProgram(undefined);
        setTextErrorMessageDialog(strings.tarifficationErrorMessage);
        setTextDetailErrorMessageDialog(`${response.errorResponse.text}; ${response.errorResponse.detailText}`);
        setOpenErrorMessageDialog(true);
    };

    const onFormSubmit = (submittedQuotation: MtplQuotation) => {
        if (showOrNotTechnicalWorkPage()) return;
        const date = new Date();
        log.sendLog(date, LogFunctionalModule.STORE_EMTPL, 'INFO',`${currentStep}_NEXT_HANDLER`, [{ quotation: quotation, currentStep: currentStep }], '')
        setProcessingOpen(true);
        submittedQuotation.vtplAdditionalCoverage.covered = true;
        submittedQuotation.cascoAdditionalCoverage.covered = true;

        setQuotation(submittedQuotation);

        setSelectedVtplSumInsured(undefined);
        setSelectedVtplCovered(undefined);
        setSelectedVtplPremium(undefined);

        calculate(submittedQuotation, ProductType.EMTPL)
            .then(response => handleCalculationResponse(response, submittedQuotation));
    };

    const onPackageSelect = (deductible: number, cascoCovered: boolean, totalPremium: number, vtplCovered: boolean, vtplSumInsured: number, mtplPremium: number, vtplPremium: number, cascoPremium: number) => {
        const date = new Date();
        log.sendLog(date, LogFunctionalModule.STORE_EMTPL, 'INFO',"PACKAGE_SELECT_HANDLER", [{ quotation: quotation }], '')
        quotation.mtplContract.deductible = deductible;
        quotation.mtplContract.premium = mtplPremium;
        quotation.cascoAdditionalCoverage = {
            covered: cascoCovered,
            ownerIsInsured: quotation.cascoAdditionalCoverage?.ownerIsInsured ?? true,
            engineCapacity: quotation.cascoAdditionalCoverage?.engineCapacity ?? 0,
            ownerName: quotation.cascoAdditionalCoverage?.ownerName ?? "",
            ownerBirthDate: quotation.cascoAdditionalCoverage?.ownerBirthDate ?? null,
            ownerAddress: quotation.cascoAdditionalCoverage?.ownerAddress ?? "",
            premium: cascoPremium
        };

        quotation.vtplAdditionalCoverage = {
            covered: vtplCovered,
            sumInsured: vtplSumInsured,
            premium: vtplPremium
        };
        quotation.totalPremium = mtplPremium + (cascoCovered ? cascoPremium : 0) + (vtplCovered ? vtplPremium : 0);

        setTotalPremium(totalPremium);
        nextStepListener(quotation);
    };

    const onRecalculate = () => {
        setTariffied(false);
    };

    useEffect(() => {
        saveTempValues('tariffied', tariffied ? 'true' : 'false')
    }, [tariffied])

    return {
        tariffied,
        setTextErrorMessageDialog,
        setTextDetailErrorMessageDialog,
        setOpenErrorMessageDialog,
        packages,
        onPackageSelect,
        onRecalculate,
        onFormSubmit
    };
};
